import { createReducer, on } from '@ngrx/store';
import { CustomerActions } from './customer.actions';
import { Customer, Pagination, Type } from '@core/interface/customer';

export const CustomerFeatureKey = 'customer';

export interface CustomerState {
  customers: Customer[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
  types: Type[];
}

export const initialState: CustomerState = {
  customers: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
  types: [],
};

export const CustomerReducer = createReducer(
  initialState,
  on(CustomerActions.loadCustomers, (state) => ({
    ...state,
    customers: [],
    isLoading: true,
  })),
  on(CustomerActions.loadCustomersSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    customers: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
  })),
  on(CustomerActions.loadCustomersFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(CustomerActions.addCustomerSuccess, (state, { data }) => ({
    ...state,
    customers: [...state.customers, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(CustomerActions.addCustomerFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(CustomerActions.updateCustomerSuccess, (state, { data }) => ({
    ...state,
    customers: state.customers.map((Customer) =>
      data.id == Customer.id ? data : Customer
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(CustomerActions.updateCustomerFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(CustomerActions.deleteCustomerSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    customers: state.customers.filter((Customer) => Customer.id !== id),
  })),
  on(CustomerActions.deleteCustomerFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(CustomerActions.deleteCustomer, (state) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(CustomerActions.loadCustomerType, (state) => ({ ...state, types: [] })),
  on(CustomerActions.loadCustomerTypeSuccess, (state, { data }) => ({
    ...state,
    types: data,
    isDeleted: false,
    loadTypeError: null,
  })),
  on(CustomerActions.loadCustomerTypeFailure, (state, { error }) => {
    return {
      ...state,
      loadTypeError: error,
      isDeleted: false,
    };
  }),

  on(CustomerActions.addEditCustomerTypeSuccess, (state, { data }) => ({
    ...state,
    types: [...state.types, data],
    isDeleted: false,
    addEditTypeError: null,
  })),
  on(CustomerActions.addEditCustomerTypeFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditTypeError: error,
  })),
  on(CustomerActions.updateCustomerTypeSuccess, (state, { data }) => ({
    ...state,
    type: state.customers.map((type) => (data.id == type.id ? data : type)),
    isDeleted: false,
    addEditTypeError: null,
  })),
  on(CustomerActions.updateCustomerTypeFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditTypeError: error,
  })),
  on(CustomerActions.deleteCustomerTypeSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteTypeError: null,
    types: state.types.filter((type) => type.id !== id),
  })),
  on(CustomerActions.deleteCustomerTypeFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteTypeError: error,
  })),
  on(CustomerActions.deleteCustomerType, (state) => ({
    ...state,
    isDeleted: false,
    deleteTypeError: null,
  })),
  on(CustomerActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  }))
);
